/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ message: NonNullable<unknown> }} Automatic_Save_Project_Save_FailedInputs */

const en_automatic_save_project_save_failed = /** @type {(inputs: Automatic_Save_Project_Save_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Project saved failed. ${i?.message}`)
};

const fr_automatic_save_project_save_failed = /** @type {(inputs: Automatic_Save_Project_Save_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Échec de l’enregistrement du projet. ${i?.message}`)
};

const de_automatic_save_project_save_failed = /** @type {(inputs: Automatic_Save_Project_Save_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Projektspeicherung fehlgeschlagen. ${i?.message}`)
};

const it_automatic_save_project_save_failed = /** @type {(inputs: Automatic_Save_Project_Save_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Progetto salvato non riuscito. ${i?.message}`)
};

const ru_automatic_save_project_save_failed = /** @type {(inputs: Automatic_Save_Project_Save_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Проект не удалось сохранить. ${i?.message}`)
};

const es_automatic_save_project_save_failed = /** @type {(inputs: Automatic_Save_Project_Save_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`El proyecto guardado falló. ${i?.message}`)
};

const zh_cn2_automatic_save_project_save_failed = /** @type {(inputs: Automatic_Save_Project_Save_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`项目保存失败。${i?.message}`)
};

const ja_automatic_save_project_save_failed = /** @type {(inputs: Automatic_Save_Project_Save_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`プロジェクトの保存に失敗しました。${i?.message}`)
};

const hi_automatic_save_project_save_failed = /** @type {(inputs: Automatic_Save_Project_Save_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`प्रोजेक्ट सेव करने में विफल। ${i?.message}`)
};

const pt_pt2_automatic_save_project_save_failed = /** @type {(inputs: Automatic_Save_Project_Save_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Projeto salvo falhou. ${i?.message}`)
};

/**
* | output |
* | --- |
* | "Project saved failed. {message}" |
*
* @param {Automatic_Save_Project_Save_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const automatic_save_project_save_failed = /** @type {((inputs: Automatic_Save_Project_Save_FailedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automatic_Save_Project_Save_FailedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_automatic_save_project_save_failed(inputs)
	if (locale === "de") return de_automatic_save_project_save_failed(inputs)
	if (locale === "it") return it_automatic_save_project_save_failed(inputs)
	if (locale === "ru") return ru_automatic_save_project_save_failed(inputs)
	if (locale === "es") return es_automatic_save_project_save_failed(inputs)
	if (locale === "zh-CN") return zh_cn2_automatic_save_project_save_failed(inputs)
	if (locale === "ja") return ja_automatic_save_project_save_failed(inputs)
	if (locale === "hi") return hi_automatic_save_project_save_failed(inputs)
	if (locale === "pt-PT") return pt_pt2_automatic_save_project_save_failed(inputs)
	return en_automatic_save_project_save_failed(inputs)
});